module.exports = __webpack_public_path__ + "static/media/Морозов К., Чижов К..be1b5834.pdf";